import React from 'react'
import { Link } from 'react-router-dom'

const Home = () => {
  return (
    <div>
      <header id="head">
        {/* <div className="home_navbar">
          <p>Home</p>
        </div> */}
        <div className="banner-content">
          <h1>GEOSPATIAL SMART<br /> THINKERS</h1>
          <p>Unleash the Power of Map Visualization with Our Interactive and Insightful Choropleth Map </p>
          <Link to="/map" onClick={() => window.scrollTo(0, 0)}> <button className='home_page_btn'>
            Create a Choropleth Map</button></Link>
        </div>
        {/* <div className="footer_container">
          <h4>Made for India</h4>
        </div> */}
      </header>

    </div>
  )
}

export default Home